<template>
  <section>
    <div class="topleft"></div>
    <ul v-if="store.StoreID==0" class="nav">
      <li v-on:click="OnTypeClick(0)">
        <a :class="selectType==0?'selected':''">
          <h2>所有</h2>
        </a>
      </li>
      <li v-on:click="OnTypeClick(3)">
        <a :class="selectType==3?'selected':''">
          <h2>单体门店</h2>
        </a>
      </li>
      <li v-on:click="OnTypeClick(1)">
        <a :class="selectType==1?'selected':''">
          <h2>连锁总部</h2>
        </a>
      </li>
      <li v-on:click="OnTypeClick(2)">
        <a :class="selectType==2?'selected':''">
          <h2>连锁门店</h2>
        </a>
      </li>
      <li v-on:click="OnTypeClick(4)">
        <a :class="selectType==4?'selected':''">
          <h2>医院诊所</h2>
        </a>
      </li>
      <li v-on:click="OnTypeClick(5)">
        <a :class="selectType==5?'selected':''">
          <h2>整改企业</h2>
        </a>
      </li>
      <li v-on:click="OnTypeClick(6)">
        <a :class="selectType==6?'selected':''">
          <h2>系统公告</h2>
        </a>
      </li>
    </ul>
    <ul class="nav" v-else>
      <li v-if="this.store.StoreType!=1" v-on:click="OnTypeClick(8)">
        <a :class="selectType==8?'selected':''">
          <h2>设备信息</h2>
        </a>
      </li>
      <li v-if="this.store.StoreType==1" v-on:click="OnTypeClick(10)">
        <a :class="selectType==10?'selected':''">
          <h2>连锁总部</h2>
        </a>
      </li>
      <li v-if="this.store.StoreType==1" v-on:click="OnTypeClick(11)">
        <a :class="selectType==11?'selected':''">
          <h2>连锁门店</h2>
        </a>
      </li>
      <li v-on:click="OnTypeClick(5)">
        <a :class="selectType==5?'selected':''">
          <h2>整改报告</h2>
        </a>
      </li>
      <li v-on:click="OnTypeClick(6)">
        <a :class="selectType==6?'selected':''">
          <h2>系统公告</h2>
        </a>
      </li>
      <!-- <li v-if="store.StoreID!=0" v-on:click="OnTypeClick(7)">
        <a :class="selectType==7?'selected':''">
          <h2>服务续费</h2>
        </a>
      </li>-->
      <li v-on:click="OnTypeClick(9)">
        <a :class="selectType==9?'selected':''">
          <h2>第三方对接</h2>
        </a>
      </li>
      <li v-if="this.store.StoreType==1" v-on:click="OnTypeClick(12)">
        <a :class="selectType==12?'selected':''">
          <h2>报警设置</h2>
        </a>
      </li>
    </ul>

    <div class="topright">
      <ul>
        <li>
          <router-link v-if="this.store.StoreType==1" to="/trilateralstoreconfig">数据上报</router-link>
          <router-link v-if="this.store.StoreType!=1" to="/trilateralconfig">数据上报</router-link>
        </li>
        <li>
          <router-link to="/storelist">机构管理</router-link>
        </li>
        <li>
          <router-link to="/wxauthorization">消息通知</router-link>
        </li>
        <li>
          <router-link to="/wxauthorization2">重要消息</router-link>
        </li>
        <li>
          <router-link to="/userlist">账号设置</router-link>
        </li>
        <li>
          <a href="javascript:void(0)" @click="OnLoginOutClick">退出</a>
        </li>
      </ul>
      <div class="user">
        <span>{{UserName}}</span>
      </div>
    </div>
  </section>
</template>
<script>
import { BzAjax, BzJs, BzMsg, BzUser } from '../assets/script/utils'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
export default {
  name: 'Top',
  data() {
    return {
      ShowType: 1,
      list: [],
      UserName: BzUser.get().UserName,
      selectType: 0,
      containeriframeurl: '',
      ydvMonitorID: 0,
    }
  },
  computed: {
    ...mapGetters({ store: 'getState' }),
  },
  methods: {
    OnLoginOutClick() {
      BzUser.deleteuser()
      this.$router.push('/login')
    },
    OnTypeClick: function (TypeID) {
      this.selectType = TypeID
      if (TypeID == 6) {
        this.$router.push({
          name: 'noticelist',
        })
      } else if (TypeID == 5) {
        this.$router.push('/storewarn/' + this.store.selectArea)
      } else if (TypeID == 7) {
        this.$router.push({
          name: 'monitorlist',
        })
      } else if (TypeID == 9) {
        this.$router.push({
          name: 'opendevelopment',
        })
      } else if (TypeID == 12) {
        this.$router.push({
          name: 'MessageDetalis',
        })
      } else if (TypeID == 8) {
        this.$router.push('/rightls/' + this.store.StoreID + '/0/0/0')
      } else if (TypeID == 10) {
        this.$router.push('/rightls/' + this.store.StoreID + '/0/0/1')
      } else if (TypeID == 11) {
        this.$router.push('/rightls/' + this.store.StoreID + '/0/0/2')
      } else {
        this.$router.push('/client/' + this.selectType + '/' + this.store.selectArea)
      }
    },
  },
}
</script>
<style lang="less">
.topleft {
  height: 88px;
  background: url(../assets/images/topleft.jpg) no-repeat;
  float: left;
  width: 200px;
}
.topleft img {
  margin-top: 12px;
  margin-left: 10px;
}
.topright {
  height: 88px;
  background: url(../assets/images/topright.jpg) no-repeat right;
  float: right;
}
.nav {
  float: left;
}
.nav li {
  float: left;
  width: 87px;
  height: 88px;
  line-height: 88px;
  text-align: center;
}
.nav li a {
  display: block;
  width: 87px;
  height: 88px;
  -moz-transition: none;
  transition: background-color 0.3s linear;
  -moz-transition: background-color 0.3s linear;
  -webkit-transition: background-color 0.3s linear;
  -o-transition: background-color 0.3s linear;
}
.nav li a.selected {
  position: absolute;
  background: url(../assets/images/navbg.png) no-repeat;
}
.nav li a:hover {
  position: absolute;
  display: block;
  background: #000;
  color: #fff;
  background: none repeat scroll 0% 0% rgb(43, 127, 181);
}
.nav li img {
  margin-top: 10px;
}
.nav li a {
  display: block;
}
.nav a h2 {
  font-size: 14px;
  color: #d6e8f1;
  margin: 0px;
}
.nav a:hover h2 {
  color: #fff;
}
.topright ul {
  padding-top: 15px;
  float: right;
  padding-right: 12px;
}
.topright ul li {
  float: left;
  padding-left: 9px;
  padding-right: 9px;
  background: url(../assets/images/line.gif) no-repeat right;
}
.topright ul li:last-child {
  background: none;
}
.topright ul li a {
  font-size: 13px;
  color: #e9f2f7;
}
.topright ul li a:hover {
  color: #fff;
}
.topright ul li span {
  margin-top: 2px;
  float: left;
  padding-right: 3px;
}
.containeriframe {
  display: inline-block;
  width: 100%;
  height: calc(100vh - 100px);
}

.container {
  display: flex;
}
.top {
  height: 88px;
  background: url(../assets/images/topbg.gif) repeat-x;
  .topleft {
    width: 100px;
    background: url(../assets/images/topleft.jpg) no-repeat;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue